export enum SmoWorld {
  capKingdom = 'cap_kingdom',
  cascadeKingdom = 'cascade_kingdom',
  sandKingdom = 'sand_kingdom',
  lakeKingdom = 'lake_kingdom',
  woodedKingdom = 'wooded_kingdom',
  cloudKingdom = 'cloud_kingdom',
  lostKingdom = 'lost_kingdom',
  metroKingdom = 'metro_kingdom',
  snowKingdom = 'snow_kingdom',
  seasideKingdom = 'seaside_kingdom',
  luncheonKingdom = 'luncheon_kingdom',
  ruinedKingdom = 'ruined_kingdom',
  bowserKingdom = 'bowser_kingdom',
  mushroomKingdom = 'mushroom_kingdom',
  moonKingdom = 'moon_kingdom'
}
